module.exports = ['PR', 'AS', 'FM', 'GU', 'MH', 'MP', 'PW']